"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteTariffChangeEventMutation = exports.useFetchTariffAuditLogQuery = exports.useFetchTariffHistoryQuery = exports.useDeleteTariffMutation = exports.useUpdateTariffMutation = exports.useFetchTariffQuery = exports.useSearchTariffsQuery = exports.useFetchChargeRatesQuery = exports.useFetchTariffsQuery = exports.ratePeriodApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.ratePeriodApi = (0, react_1.createApi)({
    reducerPath: "ratePeriodApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["ratePeriod"],
    endpoints: function (builder) { return ({
        fetchTariffs: builder.query({
            query: function (obj) { return ({
                url: "/v1/tariff/all",
                method: "GET",
                params: __assign({ page: obj.page, limit: obj.limit }, (obj.current !== undefined && { current: obj.current })),
            }); },
            providesTags: ["ratePeriod"],
        }),
        fetchChargeRates: builder.query({
            query: function (obj) { return ({
                url: "/v1/tariff/charge-rates",
                method: "GET",
                params: __assign({ voltageLevel: obj.voltageLevel, transmissionZone: obj.transmissionZone }, (obj.locality && { locality: obj.locality })),
            }); },
            providesTags: ["ratePeriod"],
        }),
        searchTariffs: builder.query({
            query: function (obj) {
                var params = {
                    page: obj.page || 1,
                    limit: obj.limit || 10,
                };
                if (obj.search)
                    params.search = obj.search;
                if (obj.isActive !== undefined)
                    params.isActive = obj.isActive;
                if (obj.period)
                    params.period = obj.period;
                if (obj.sortBy)
                    params.sortBy = obj.sortBy;
                if (obj.sortOrder)
                    params.sortOrder = obj.sortOrder;
                return {
                    url: "/v1/tariff/all",
                    method: "GET",
                    params: params,
                };
            },
            providesTags: ["ratePeriod"],
        }),
        fetchTariff: builder.query({
            query: function (tariffId) { return ({
                url: "/v1/tariff/fetch",
                method: "GET",
                params: { _id: tariffId },
            }); },
            providesTags: ["ratePeriod"],
        }),
        updateTariff: builder.mutation({
            query: function (obj) { return ({
                url: "/v1/tariff/update",
                method: "PUT",
                body: obj,
            }); },
            invalidatesTags: ["ratePeriod"],
        }),
        deleteTariff: builder.mutation({
            query: function (_a) {
                var tariffId = _a.tariffId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tariff/remove",
                    method: "DELETE",
                    params: __assign({ _id: tariffId, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["ratePeriod"],
        }),
        fetchTariffHistory: builder.query({
            query: function (tariffId) { return ({
                url: "/v1/tariff/history",
                method: "GET",
                params: { _id: tariffId },
            }); },
            providesTags: function (_result, _err, tariffId) { return [{ type: "ratePeriod", id: "history:".concat(tariffId) }]; },
        }),
        fetchTariffAuditLog: builder.query({
            query: function (_a) {
                var tariffId = _a.tariffId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/tariff/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: tariffId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "ratePeriod", id: "audit:".concat(arg.tariffId) }]; },
        }),
        deleteTariffChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tariff/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "ratePeriod", id: "audit:".concat(arg.tariffId) },
                { type: "ratePeriod", id: "history:".concat(arg.tariffId) },
            ]; },
        }),
    }); },
});
exports.useFetchTariffsQuery = exports.ratePeriodApi.useFetchTariffsQuery, exports.useFetchChargeRatesQuery = exports.ratePeriodApi.useFetchChargeRatesQuery, exports.useSearchTariffsQuery = exports.ratePeriodApi.useSearchTariffsQuery, exports.useFetchTariffQuery = exports.ratePeriodApi.useFetchTariffQuery, exports.useUpdateTariffMutation = exports.ratePeriodApi.useUpdateTariffMutation, exports.useDeleteTariffMutation = exports.ratePeriodApi.useDeleteTariffMutation, exports.useFetchTariffHistoryQuery = exports.ratePeriodApi.useFetchTariffHistoryQuery, exports.useFetchTariffAuditLogQuery = exports.ratePeriodApi.useFetchTariffAuditLogQuery, exports.useDeleteTariffChangeEventMutation = exports.ratePeriodApi.useDeleteTariffChangeEventMutation;
